import React from 'react'
import { TitleXS } from '@/atoms/Text'
import { CollectibleSceneLabel } from '@/organisms/CollectibleSceneInfo/CollectibleSceneLabel'
import { useCollectiblesPlayerEngagement } from '@/organisms/CollectiblesPlayer/CollectiblesPlayerEngagement/CollectiblesPlayerEngagementContext'
import { ShareMoment } from '../ShareMoment'
import { CollectiblePurchasePromo } from './CollectiblePurchasePromo'
import { CollectibleSceneDetails } from './CollectibleSceneDetails'
import { EngagementDetailOverlay } from './EngagementDetailOverlay'

export const CollectibleSceneInfo: React.FC<{ hideMomentFullscreen?: boolean }> = ({
  hideMomentFullscreen = false,
}) => {
  const { engagementMoment, defaultEngagementDetail } = useCollectiblesPlayerEngagement()

  if (!engagementMoment)
    return (
      <div className="flex flex-wrap">
        <div className="h-[120px] w-full rounded-xl bg-black" />
        <div className="my-4 h-80 w-full rounded-xl bg-black" />
        <div className="h-80 w-full rounded-xl bg-black" />
      </div>
    )

  return (
    <EngagementDetailOverlay
      defaultEngagementDetail={defaultEngagementDetail}
      hideMomentFullscreen={hideMomentFullscreen}
    >
      <div className="px-4">
        <div className="mx-3 mb-5 flex items-end pt-6 md:pt-8 lg:pt-5">
          <div>
            <CollectibleSceneLabel type={engagementMoment?.type} />
            <TitleXS color="white" className="lg:photon-title-sm" weight="semibold">
              {engagementMoment.title}
            </TitleXS>
          </div>
          <div className="ml-auto">
            <ShareMoment moment={engagementMoment} />
          </div>
        </div>
        <CollectiblePurchasePromo slug={engagementMoment?.projectSlug ?? ''} />
        <CollectibleSceneDetails />
      </div>
    </EngagementDetailOverlay>
  )
}
